<template>
	<div role="region" aria-label="Booking Container">
		<booking-fullwidth
			v-if="template == 'full-width'"
			:open_booking="open_booking"
			:booking_object="booking_object"
			:booking_data="booking_data"
			:showRates="showRates"
			:booking_engine_site_setup="this.booking_engine_site_setup"
			@update-data="updateBookingData"
			@close-booking="closeBooking"
			@request-booking="requestBooking"
		>
		</booking-fullwidth>
		<booking-halfwidth
			v-if="template == 'half-width'"
			:open_booking="open_booking"
			:booking_object="booking_object"
			:booking_data="booking_data"
			:showRates="showRates"
			:booking_engine_site_setup="this.booking_engine_site_setup"
			@update-data="updateBookingData"
			@close-booking="closeBooking"
			@request-booking="requestBooking"
		>
		</booking-halfwidth>
		<booking-fixed
			v-if="template == 'fixed'"
			ref="template"
			:open_booking="open_booking"
			:booking_object="booking_object"
			:booking_data="booking_data"
			:showRates="showRates"
			:booking_engine_site_setup="this.booking_engine_site_setup"
			@update-data="updateBookingData"
			@close-booking="closeBooking"
			@request-booking="requestBooking"
		>
		</booking-fixed>
	</div>
</template>

<script>
import SymphonyBooking from './lib/SymphonyBooking';

import SymphonyBookingAPI from './services/SymphonyBookingAPI';

import { isLightColor } from './lib/helpers';

import BookingFixed from './templates/BookingFixed.vue';
import BookingFullwidth from './templates/BookingFullwidth.vue';
import BookingHalfwidth from './templates/BookingHalfwidth.vue';

export default {
	name: 'BookingWidgetSymphony',
	components: {
		BookingFixed,
		BookingFullwidth,
		BookingHalfwidth,
	},
	data() {
		return {
			triggerHash: '#_booking',
			open_booking: false,
			booking_url_site_setup: '',
			booking_engine_site_setup: '',
			template: '',
			test_mode: false,
			booking_data: {
				checkin: '',
				checkout: '',
				rooms: '',
				adults: '',
				children: '',
				promo: '',
			},
			booking_object: {},
			showRates: false,
			ihg_tracking_js: null,
		};
	},
	methods: {
		hashChange() {
			const hash = location.hash;
			if (window.screen.width > 700) {
				if (hash != this.triggerHash) {
					this.open_booking = false;
				} else {
					this.open_booking = true;
				}
			}
		},
		updateBookingData(field = {}) {
			//field = { promo : 'xfx405' }
			this.booking_data = {
				...this.booking_data,
				...field,
			};
		},
		requestBooking() {
			let params = '';
			let url = '';
			let fullOrigin = '';

			const urlParams = SymphonyBooking.buildParamsBooking({
				engine: this.booking_engine_site_setup,
				bookingData: this.booking_data,
			});

			const { origin, query, href, hash } = SymphonyBooking.buildUrlBooking(this.booking_url_site_setup);

			if (hash !== '') {
				fullOrigin = href;
				params = urlParams;
			} else {
				fullOrigin = origin;
				if (query === '') {
					params = `?${urlParams}`;
				} else {
					params = `${query}&${urlParams}`;
				}
			}
			if (is_live === '1') {
				//IHG tracking
				const newUrl = this.ihg_tracking_js ? `${fullOrigin}${params}&cm_mmc=${this.ihg_tracking_js}` : `${fullOrigin}${params}`;
				SymphonyBooking.decorateUrlGA4New(newUrl);
			} else {
				url = `${fullOrigin}${params}`;
				window.open(url, '_blank');
			}
		},
		openBooking() {
			if (window.screen.width < 700) {
				let url = this.booking_object.extras.bookingUrl && this.booking_object.extras.bookingUrl != '' ? this.booking_object.extras.bookingUrl : this.booking_object.functionality.bookingUrl;
				window.open(url, '_blank');
			} else {
				this.open_booking = !this.open_booking;
			}
		},
		closeBooking() {
			this.open_booking = false;
			if (window.location.href.indexOf('#_booking') !== -1) {
				let separateURL = window.location.href.split('#_booking');
				const stateObj = { foo: 'bar' };
				history.pushState(stateObj, '', separateURL[0]);
			}
		},

		initBookingListeners() {
			const urlBase = new URL(window.location.href);
			let queryParams = new URLSearchParams(urlBase.search);

			if (this.test_mode === false || queryParams.get('enable_cms_booking') == 'true') {
				var eventToggleBooking = new Event('openBooking');

				window['eventToggleBooking'] = eventToggleBooking;

				window.addEventListener('openBooking', (evt) => {
					this.openBooking();
				});

				document.querySelectorAll('.bookingCMS').forEach((btn) => {
					btn.addEventListener('click', (e) => {
						e.preventDefault();
						this.open_booking = !this.open_booking;

						// Change focus to close link after the DOM updates
						const bookingComponent = document.querySelector('.booking-cms');

						if (bookingComponent) {
							bookingComponent.setAttribute('tabindex', '0');
							bookingComponent.focus();
						}
					});
				});

				this.hashChange();

				window.onhashchange = (e, elm) => {
					this.hashChange();
				};

				//Scroll listeners just only for fixed template
				if (this.template === 'fixed') {
					if (document.querySelector('#home') === null) {
						this.open_booking = false;
					} else {
						setTimeout(() => {
							this.open_booking = true;
						}, 10);
					}
					window.addEventListener('scroll', this.scrollListenerBehavior);
				}
			} else {
				document.querySelectorAll('.bookingCMS').forEach((btn) => {
					btn.setAttribute('target', '_blank');
				});
			}
		},

		scrollListenerBehavior() {
			if (document.querySelector('#home') === null) {
				this.open_booking = false;
			} else {
				if (window.scrollY > 10) {
					this.open_booking = false;
				} else {
					this.open_booking = true;
				}
			}
		},
	},
	beforeMount() {
		SymphonyBookingAPI.getBookingConfig().then((resp) => {
			this.booking_object = resp.data.bookingWidget;
			this.template = this.booking_object.layout.template;
			this.test_mode = this.booking_object.functionality['test-mode'];
			this.booking_url_site_setup = this.booking_object.extras.bookingUrl && this.booking_object.extras.bookingUrl != '' ? this.booking_object.extras.bookingUrl : resp.data.bookingUrl;
			this.booking_engine_site_setup = resp.data.bookingEngine;
			const iconsDefault = {
				calendar: isLightColor(this.booking_object.layout.backgroundColor)
					? 'https://symphony.cdn.tambourine.com/tambourine-2020/media/icon-calendar-dark-6480dafa81189.svg'
					: 'https://symphony.cdn.tambourine.com/tambourine-2020/media/icon-calendar-white-6480dafab2941.svg',

				arrow: isLightColor(this.booking_object.calendar.header.backgroundColor)
					? 'https://symphony.cdn.tambourine.com/tambourine-2020/media/icon-arrow-dark-6480daf9cc969.svg'
					: 'https://symphony.cdn.tambourine.com/tambourine-2020/media/icon-arrow-white-6480dafa38901.svg',

				select: isLightColor(this.booking_object.layout.backgroundColor)
					? 'https://symphony.cdn.tambourine.com/tambourine-2020/media/icon-select-dark-6480dafb0cb2b.svg'
					: 'https://symphony.cdn.tambourine.com/tambourine-2020/media/icon-select-white-6480dafb5ec95.svg',
			};

			this.booking_object = {
				...this.booking_object,
				icons: {
					...this.booking_object.icons,
					arrow: this.booking_object.icons.arrow !== '' && this.booking_object.icons.arrow !== undefined ? this.booking_object.icons.arrow : iconsDefault['arrow'],
					calendar: this.booking_object.icons.calendar !== '' && this.booking_object.icons.calendar !== undefined ? this.booking_object.icons.calendar : iconsDefault['calendar'],
					select: this.booking_object.icons.select !== '' && this.booking_object.icons.select !== undefined ? this.booking_object.icons.select : iconsDefault['select'],
				},
			};

			//Show Rates validation
			let valShowRates = false;
			if (this.booking_object.functionality.rates !== undefined) {
				valShowRates = this.booking_object.functionality.rates.showRates;
			}
			this.showRates = this.booking_engine_site_setup === 'Travel Tripper' && valShowRates === true ? true : false;

			this.initBookingListeners();

			if (this.template == 'fixed' && document.getElementById('home')) {
				//document.querySelectorAll('.bookingCMS').forEach((btn)=> btn.classList.add("hidden"));
			}
		});
	},
	mounted() {
		if (typeof ihg_tracking !== 'undefined') this.ihg_tracking_js = ihg_tracking;
	},
};
</script>

<style lang="scss">
.booking-cms {
	position: fixed;
	width: 100%;
	height: 100vh;
	z-index: 100;
	transition-property: top, right, bottom, left, opacity;
	transition-duration: 0.8s;
	transition-timing-function: ease-in-out;
	&__content {
		position: absolute;
		top: 50%;
		width: 100%;
		transform: translateY(-65%);
	}
	&__header {
		max-width: 1170px;
		margin: 60px auto 50px auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 20px 0 12px;
		h2,
		h3 {
			margin: 12px 0;
		}
		.close-icon {
			color: transparent;
			text-transform: uppercase;
			transition: all 0.3s ease-in-out;
			font-size: 12px;
			cursor: pointer;
			span {
				position: relative;
				color: transparent;
				&:before,
				&:after {
					content: '';
					position: absolute;
					top: 5px;
					left: 5px;
					width: 25px;
					height: 2px;
					background-color: var(--color-close);
					transition: all 0.4s ease-in-out;
				}
				&:before {
					transform: rotate(45deg);
				}
				&:after {
					transform: rotate(-45deg);
				}
				&:hover {
					&:before,
					&:after {
						transform: rotate(0deg);
					}
				}
			}
			&:hover {
				opacity: 0.7;
			}
		}
	}
	.field-container {
		line-height: 1;
	}
	&.one-calendar {
		.booking-cms__header {
			max-width: 825px;
		}
	}
	&__body {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__form {
		max-width: 350px;
		width: 100%;
		margin-left: 70px;
	}

	&.top {
		top: -200vh;
		left: 0;
	}
	&.left {
		left: -300vh;
		top: 0;
	}
	&.right {
		right: -300vh;
		top: 0;
	}
	&.bottom {
		bottom: -200vh;
		left: 0;
	}
	&.open_booking {
		&.top {
			top: 0;
		}
		&.left {
			left: 0;
		}
		&.right {
			right: 0;
		}
		&.bottom {
			bottom: 0;
		}
	}
}

@media only screen and (max-width: 1100px) {
	.booking-cms {
		&__header {
			max-width: 770px;
			margin: 20px auto;
		}
	}
}

@media only screen and (max-width: 900px) {
	.booking-cms {
		&__header {
			max-width: 85%;
		}
		&__form {
			margin-left: 10px;
		}
	}
}
</style>
